export default {
  title: 'Śledź swoje zamówienie',
  text: 'Dziękujemy za złożenie zamówienia! Nasze partnerstwo z <0>{{carrier}}</0> pozwala nam realizować dostawy bezpośrednio na naszej stronie, oszczędzając średnio {{savings}} na prowizjach. Twoje zamówienie zostanie dostarczone przez <1>{{carrier}}</1>, zapewniając doskonałą obsługę 😊',
  labels: {
    delivered_by: 'Dostarcza',
  },
  buttons: {
    track_order: 'Śledź zamówienie na żywo →',
    track_order_once_confirmed: 'Śledź zamówienie na żywo po potwierdzeniu',
  },
};
